/**
 * Class representing a reason for absence.
 */
export default class ReasonForAbsenceModel {
  /**
   * Create a reason for absence.
   * @param {number} id - The unique identifier for the reason.
   * @param {string} name - The name of the reason to be displayed to the user.
   */
  constructor(id, name) {
    /**
     * The unique identifier for the reason.
     * @type {number}
     */
    this.id = id
    /**
     * The name of the reason to be displayed to the user.
     * @type {string}
     */

    this.name = name
  }
}
